export class LicenseAssignConfig {
  public OrganizationID: number;
  public LicenseID: number;
}
